/* eslint-disable no-restricted-globals, import/named */
import { poiBankRequest } from '../apis/main';
import { getAutoCompleteV2 } from '../apis/poiBank';
import {
  fetchDetailFromPoiBankUrl,
  fetchCityAutoCompleteUrl,
  fetchRecommendedPoiUrl,
  searchPoiUrl,
  cityGeocodeUrl,
  geocodingUrl
} from '../utilities/url_util';
import {
  FETCH_POI_DETAIL_FROM_POI_BANK_SUCCESS,
  FETCH_POI_DETAIL_FROM_POI_BANK_FAIL,
  FETCH_POI_DETAIL_FROM_POI_BANK,
  FETCH_CITY_AUTOCOMPLETE_SUCCESS,
  FETCH_CITY_AUTOCOMPLETE_FAIL,
  FETCH_CITY_AUTOCOMPLETE,
  CLEAR_CITY_AUTOCOMPLETE,
  FETCH_RECOMMENDED_POI_SUCCESS,
  FETCH_RECOMMENDED_POI_FAIL,
  FETCH_RECOMMENDED_POI,
  RESET_RECOMMENDED_POI,
  SET_RECOMMENDED_POI,
  SEARCH_POI_SUCCESS,
  SEARCH_POI_FAIL,
  POI_BANK_CITY_GEOCODE_SUCCESS,
  POI_BANK_CITY_GEOCODE_FAIL,
  POI_BANK_CITY_GEOCODE,
  GEO_CODE_SUCCESS,
  GEO_CODE_FAIL,
  GEO_CODE,
  CLEAR_POI_LIST,
  CACHE_SEARCH_CITY,
  SET_NORTHEAST_AND_SOUTHEAST
} from './action_types';
import { VIEW_STATE_ITINERARY } from '../reducers/view_state';
import { POI_BANK_NEXT_STATUS_SUCCESS } from '../utilities/constants';
import { normalizeKeyword } from '../utilities/autocomplete';

// todo: migrate all url constants in link_util to /src/apis/poiBank.js
// poi bank - fetch poi detail from poi bank request
export const fetchPoiDetailFromPoiBank =
  (token, tripObjectId, folderObjectId, poi, language, type) => dispatch => {
    const url = fetchDetailFromPoiBankUrl();
    const { _id: poiObjectId, poiBankNextId: poiBankId } = poi;
    dispatch({
      type: FETCH_POI_DETAIL_FROM_POI_BANK,
      payload: {
        poiObjectId,
        tripObjectId,
        folderObjectId,
        type
      }
    });

    // set headers for authorization
    const config = { headers: { Authorization: `Bearer ${token}` } };

    poiBankRequest
      .get(`${url}/${poiBankId}?hl=${language}`, config)
      .then(response => {
        const {
          data: { data, code, code_message: errorMessage }
        } = response;
        if (code === POI_BANK_NEXT_STATUS_SUCCESS) {
          dispatch({
            type: FETCH_POI_DETAIL_FROM_POI_BANK_SUCCESS,
            payload: {
              status: code,
              poiObjectId,
              tripObjectId,
              folderObjectId,
              type,
              results: data
            }
          });
        } else {
          dispatch({
            type: FETCH_POI_DETAIL_FROM_POI_BANK_FAIL,
            payload: {
              status: code,
              tripObjectId,
              folderObjectId,
              poiObjectId,
              type,
              errorMessage
            }
          });
        }
      })
      .catch(error => {
        // console.log('fetchPoiDetailFromPoiBank exception =', error.message);
        dispatch({
          type: FETCH_POI_DETAIL_FROM_POI_BANK_FAIL,
          payload: {
            status: '404',
            tripObjectId,
            folderObjectId,
            poiObjectId,
            type,
            errorMessage: error.message
          }
        });
      });
  };

export const clearCityAutocomplete = () => dispatch => {
  dispatch({ type: CLEAR_CITY_AUTOCOMPLETE });
};

export const clearPoiList = () => dispatch => {
  dispatch({ type: CLEAR_POI_LIST });
};

export const fetchCityAutocomplete = (token, keyword, language) => {
  const url = fetchCityAutoCompleteUrl();
  return dispatch => {
    dispatch({ type: FETCH_CITY_AUTOCOMPLETE, payload: { keyword } });
    const poiBankToken = localStorage.getItem('poiBankToken');
    // set headers for authorization
    const config = { headers: { Authorization: `Bearer ${poiBankToken}` } };
    const normalizationKeyword = normalizeKeyword(keyword);

    poiBankRequest
      .get(`${url}?q=${normalizationKeyword}&hl=${language}`, config)
      .then(response => {
        // console.log('fetchCityAutocomplete =', response);
        const {
          data: { data, code, code_message: errorMessage }
        } = response;
        const results = [];
        for (let i = 0; i < data.length; i++) {
          const string = data[i];
          const components = string.split('$');
          const object = {
            cityId: components[0],
            cityName: components[1],
            latitude: components[2],
            longitude: components[3],
            countryId: components[4],
            countryName: components[5],
            parentId: components[6],
            parentName: components[7],
            tag: components[8]
          };
          if (
            object.countryId.length === 0 ||
            object.countryName.length === 0
          ) {
            object.countryId = object.cityId;
            object.countryName = object.cityName;
            delete object.cityId;
            delete object.cityName;
          }
          results.push(object);
        }

        if (code === POI_BANK_NEXT_STATUS_SUCCESS) {
          dispatch({
            type: FETCH_CITY_AUTOCOMPLETE_SUCCESS,
            payload: { status, keyword, results }
          });
        } else {
          dispatch({
            type: FETCH_CITY_AUTOCOMPLETE_FAIL,
            payload: { status, keyword, errorMessage }
          });
        }
      })
      .catch(error => {
        // console.log('fetchCityAutocomplete exception =', error.message);
        dispatch({
          type: FETCH_CITY_AUTOCOMPLETE_FAIL,
          payload: { status: '404', keyword, errorMessage: error.message }
        });
      });
  };
};

export const clearCityAutocompleteV2 = () => dispatch => {
  dispatch({ type: CLEAR_CITY_AUTOCOMPLETE });
};

export const fetchAutocompleteV2 = (keyword, type, config) =>
  getAutoCompleteV2(keyword, type, config);

export const fetchCityAutocompleteV2 = keyword => {
  const TYPE_CITY = 2;
  return dispatch => {
    dispatch({ type: FETCH_CITY_AUTOCOMPLETE, payload: { keyword } });
    const normalizationKeyword = normalizeKeyword(keyword);

    fetchAutocompleteV2(normalizationKeyword, TYPE_CITY)
      .then(response => {
        // console.log('fetchCityAutocompleteV2 =', response);
        const {
          data: { data, code, code_message: errorMessage }
        } = response;
        const results = [];
        for (let i = 0; i < data.length; i++) {
          const { city: res } = data[i].extras;
          const candidate = {
            _id: Number(res.city.id),
            id: Number(res.city.id),
            name: res.city.name,
            displayName: res.name,
            location: res.location
          };
          if (res.tags) {
            candidate.tag = res.tags;
          }
          results.push(candidate);
        }

        if (code === POI_BANK_NEXT_STATUS_SUCCESS) {
          dispatch({
            type: FETCH_CITY_AUTOCOMPLETE_SUCCESS,
            payload: { status, keyword, results }
          });
        } else {
          dispatch({
            type: FETCH_CITY_AUTOCOMPLETE_FAIL,
            payload: { status, keyword, errorMessage }
          });
        }
      })
      .catch(error => {
        // console.log('fetchCityAutocomplete exception =', error.message);
        dispatch({
          type: FETCH_CITY_AUTOCOMPLETE_FAIL,
          payload: { status: '404', keyword, errorMessage: error.message }
        });
      });
  };
};

export const poiBankCityGeocode = (token, keyword, language) => {
  const url = cityGeocodeUrl();
  return dispatch => {
    dispatch({ type: POI_BANK_CITY_GEOCODE, payload: { keyword } });

    // set headers for authorization
    const config = { headers: { Authorization: `Bearer ${token}` } };
    poiBankRequest
      .get(`${url}?q=${encodeURIComponent(keyword)}&hl=${language}`, config)
      .then(response => {
        const {
          data: { data, code, code_message: errorMessage }
        } = response;
        const results = [];
        for (let i = 0; i < data.length; i++) {
          const object = data[i];
          if (!object) {
            continue;
          }
          const {
            city,
            country: { id: countryId, name: countryName },
            location: { lat, lng }
          } = object;

          const cityObj = {};
          if (city && city.id) cityObj.cityId = city.id;
          if (city && city.name) cityObj.cityName = city.name;
          if (countryId) cityObj.countryId = countryId;
          if (countryName) cityObj.countryName = countryName;
          if (lat) cityObj.latitude = lat;
          if (lng) cityObj.longitude = lng;
          results.push(cityObj);
        }

        if (code === POI_BANK_NEXT_STATUS_SUCCESS) {
          dispatch({
            type: POI_BANK_CITY_GEOCODE_SUCCESS,
            payload: { status, keyword, results }
          });
        } else {
          dispatch({
            type: POI_BANK_CITY_GEOCODE_FAIL,
            payload: { status, keyword, errorMessage }
          });
        }
      })
      .catch(error => {
        // console.log('poiBankCityGeocode exception =', error.message);
        dispatch({
          type: POI_BANK_CITY_GEOCODE_FAIL,
          payload: { status: '404', keyword, errorMessage: error.message }
        });
      });
  };
};

export const fetchRecommendedPoi =
  ({
    latitude,
    longitude,
    language,
    offset,
    limit,
    cityId,
    countryId,
    northEast,
    southEast
  }) =>
  dispatch => {
    const token = localStorage.getItem('poiBankToken');
    const config = { headers: { Authorization: `Bearer ${token}` } };

    dispatch({ type: FETCH_RECOMMENDED_POI });

    let url = `${fetchRecommendedPoiUrl()}?lat=${latitude}&lng=${longitude}&limit=${limit}&offset=${offset}&hl=${language}`;
    if (cityId && cityId.length) url += `&city_id=${cityId}`;
    if (countryId && countryId.length) url += `&country_id=${countryId}`;
    if (northEast) {
      const { lat: nelat, lng: nelng } = northEast;
      url += `&nelat=${nelat}&nelng=${nelng}`;
    }
    if (southEast) {
      const { lat: swlat, lng: swlng } = southEast;
      url += `&swlat=${swlat}&swlng=${swlng}`;
    }
    poiBankRequest
      .get(url, config)
      .then(response => {
        dispatch({
          type: FETCH_RECOMMENDED_POI_SUCCESS,
          payload: { status, latitude, longitude, results: response.data }
        });
      })
      .catch(error => {
        // console.log('fetchRecommendedPoi exception =', error.message);
        dispatch({
          type: FETCH_RECOMMENDED_POI_FAIL,
          payload: {
            status: '404',
            latitude,
            longitude,
            errorMessage: error.message
          }
        });
      });
  };

export const resetRecommendedPoi = () => ({ type: RESET_RECOMMENDED_POI });

export const setRecommendedPoi = data => ({
  type: SET_RECOMMENDED_POI,
  payload: data
});

export const searchPoi = ({
  keyword,
  latitude,
  longitude,
  language,
  offset,
  limit,
  cityId,
  countryId,
  northEast,
  southEast
}) => {
  const trimmedKeyword = encodeURIComponent(keyword);
  let url = `${searchPoiUrl()}?q=${trimmedKeyword}&lat=${latitude}&lng=${longitude}&limit=${limit}&offset=${offset}&hl=${language}`;
  if (cityId && cityId.length) url += `&city_id=${cityId}`;
  if (countryId && countryId.length) url += `&country_id=${countryId}`;
  if (northEast) {
    const { lat: nelat, lng: nelng } = northEast;
    url += `&nelat=${nelat}&nelng=${nelng}`;
  }
  if (southEast) {
    const { lat: swlat, lng: swlng } = southEast;
    url += `&swlat=${swlat}&swlng=${swlng}`;
  }
  const token = localStorage.getItem('poiBankToken');
  return dispatch => {
    const config = { headers: { Authorization: `Bearer ${token}` } };

    dispatch({ type: FETCH_RECOMMENDED_POI });

    poiBankRequest
      .get(url, config)
      .then(response => {
        dispatch({
          type: SEARCH_POI_SUCCESS,
          payload: { status, keyword, results: response.data }
        });
      })
      .catch(error => {
        dispatch({
          type: SEARCH_POI_FAIL,
          payload: { status: '404', keyword, errorMessage: error.message }
        });
      });
  };
};

export const geocode = (token, poi, shouldCache, language) => dispatch => {
  dispatch({ type: GEO_CODE, payload: { address: poi.address } });
  const url = encodeURI(`${geocodingUrl()}?q=${poi.address}&hl=${language}`);

  // set headers for authorization
  const config = { headers: { Authorization: `Bearer ${token}` } };
  poiBankRequest
    .get(url, config)
    .then(response => {
      // console.log('geocodingRequest response =', response);
      const {
        data: { code, data }
      } = response;
      if (code === POI_BANK_NEXT_STATUS_SUCCESS) {
        const object = data[0];
        const { location } = object;
        const p = poi;
        p.location = location;
        // console.log('geocodingRequest response poi =', p);
        dispatch({
          type: GEO_CODE_SUCCESS,
          payload: { status, address: poi.address, poi: p, shouldCache }
        });
      } else {
        dispatch({
          type: GEO_CODE_FAIL,
          payload: {
            status,
            address: poi.address,
            toastViewState: VIEW_STATE_ITINERARY
          }
        });
      }
    })
    .catch(error => {
      // console.log('geocodingRequest exception =', error.message);
      dispatch({
        type: GEO_CODE_FAIL,
        payload: {
          status,
          address: poi.address,
          toastViewState: VIEW_STATE_ITINERARY
        }
      });
    });
};

export const setCacheSearchCity = city => ({
  type: CACHE_SEARCH_CITY,
  payload: { city }
});

export const setNorthEastAndSouthEast = (northEast, southEast) => ({
  type: SET_NORTHEAST_AND_SOUTHEAST,
  payload: { northEast, southEast }
});
